// extracted by mini-css-extract-plugin
module.exports = {"superAdminOrganizationInfoBadge":"superAdminOrganizationInfoBadge__ZiJ3g"};